/**
 * lgk-outils-tools-ext.js — Outils supplémentaires (inspirés gothamdev.fr)
 * Étend window.LGK_OUTILS_TOOLS défini dans lgk-outils-tools.js
 */
(function () {
  'use strict';
  const T = window.LGK_OUTILS_TOOLS;
  if (!T) return;

  const VAT = { 20: 0.2, 10: 0.1, 5.5: 0.055 };
  const FX = { USD: 1.08, GBP: 0.86, CHF: 0.94 };
  const MIME = {
    pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg',
    webp: 'image/webp', gif: 'image/gif', svg: 'image/svg+xml', json: 'application/json',
    xml: 'application/xml', csv: 'text/csv', txt: 'text/plain', html: 'text/html',
    css: 'text/css', js: 'application/javascript', zip: 'application/zip',
    mp4: 'video/mp4', mp3: 'audio/mpeg', wasm: 'application/wasm',
  };

  function copyBtn(root, getText) {
    const b = root.querySelector('[data-copy]');
    if (b) b.addEventListener('click', () => {
      const t = typeof getText === 'function' ? getText() : getText;
      navigator.clipboard?.writeText(t);
    });
  }

  Object.assign(T, {
    'meta-generator': {
      title: 'Générateur balises meta',
      render: () => `<div class="lgk-outil"><label>Titre<input data-t maxlength="70"></label><label>Description<textarea data-d rows="3"></textarea></label><label>URL canonical<input data-u placeholder="https://www.legeekshop.com/"></label><label>Image OG<input data-img placeholder="https://…/image.jpg"></label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-copy>Copier HTML</button><pre class="lgk-outil__result" data-out style="white-space:pre-wrap;font-size:0.75rem"></pre></div>`,
      mount(root) {
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const t = root.querySelector('[data-t]').value;
          const d = root.querySelector('[data-d]').value;
          const u = root.querySelector('[data-u]').value;
          const img = root.querySelector('[data-img]').value;
          out.textContent = `<title>${t}</title>\n<meta name="description" content="${d}">\n<link rel="canonical" href="${u}">\n<meta property="og:title" content="${t}">\n<meta property="og:description" content="${d}">\n<meta property="og:url" content="${u}">\n<meta property="og:image" content="${img}">\n<meta name="twitter:card" content="summary_large_image">`;
        });
        copyBtn(root, () => out.textContent);
      },
    },

    'keyword-density': {
      title: 'Densité de mots-clés',
      render: () => `<div class="lgk-outil"><label>Texte<textarea data-t rows="6"></textarea></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const t = root.querySelector('[data-t]');
        const out = root.querySelector('[data-out]');
        t.addEventListener('input', () => {
          const words = t.value.toLowerCase().match(/[\p{L}\p{N}]+/gu) || [];
          const freq = {};
          words.forEach((w) => { if (w.length > 2) freq[w] = (freq[w] || 0) + 1; });
          const top = Object.entries(freq).sort((a, b) => b[1] - a[1]).slice(0, 15);
          out.innerHTML = top.length ? top.map(([w, n]) => `${w}: ${((n / words.length) * 100).toFixed(1)} % (${n})`).join('<br>') : '—';
        });
      },
    },

    'robots-txt': {
      title: 'Générateur robots.txt',
      render: () => `<div class="lgk-outil"><label>Sitemap URL<input data-sm value="https://www.legeekshop.com/sitemap.xml"></label><label><input type="checkbox" data-dis-admin checked> Disallow /admin</label><label><input type="checkbox" data-dis-cart> Disallow /cart</label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          let r = 'User-agent: *\nAllow: /\n';
          if (root.querySelector('[data-dis-admin]').checked) r += 'Disallow: /admin\n';
          if (root.querySelector('[data-dis-cart]').checked) r += 'Disallow: /cart\n';
          r += `Sitemap: ${root.querySelector('[data-sm]').value}`;
          root.querySelector('[data-out]').textContent = r;
        });
        root.querySelector('[data-gen]').click();
      },
    },

    'htaccess-gen': {
      title: 'Générateur .htaccess',
      render: () => `<div class="lgk-outil"><label><input type="checkbox" data-https checked> Force HTTPS</label><label><input type="checkbox" data-www> Force www</label><label>Redirection 301 (ancien → nouveau, une ligne par paire)<textarea data-redir placeholder="/old /new" rows="3"></textarea></label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          let h = 'RewriteEngine On\n';
          if (root.querySelector('[data-https]').checked) h += 'RewriteCond %{HTTPS} off\nRewriteRule ^ https://%{HTTP_HOST}%{REQUEST_URI} [L,R=301]\n';
          if (root.querySelector('[data-www]').checked) h += 'RewriteCond %{HTTP_HOST} !^www\\. [NC]\nRewriteRule ^ https://www.%{HTTP_HOST}%{REQUEST_URI} [L,R=301]\n';
          (root.querySelector('[data-redir]').value || '').split('\n').filter(Boolean).forEach((line) => {
            const [a, b] = line.trim().split(/\s+/);
            if (a && b) h += `Redirect 301 ${a} ${b}\n`;
          });
          root.querySelector('[data-out]').textContent = h;
        });
      },
    },

    'sitemap-xml': {
      title: 'Générateur sitemap XML',
      render: () => `<div class="lgk-outil"><label>URLs (une par ligne)<textarea data-urls rows="8" placeholder="https://www.legeekshop.com/\nhttps://www.legeekshop.com/collections/…"></textarea></label><button type="button" class="lgk-outil__btn" data-gen>Générer XML</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-copy>Copier</button><pre class="lgk-outil__result" data-out style="max-height:14rem;overflow:auto;font-size:0.7rem"></pre></div>`,
      mount(root) {
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const urls = root.querySelector('[data-urls]').value.split('\n').map((u) => u.trim()).filter(Boolean);
          const today = new Date().toISOString().slice(0, 10);
          out.textContent = `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n${urls.map((u) => `  <url><loc>${u}</loc><lastmod>${today}</lastmod></url>`).join('\n')}\n</urlset>`;
        });
        copyBtn(root, () => out.textContent);
      },
    },

    'schema-org': {
      title: 'JSON-LD Organization',
      render: () => `<div class="lgk-outil"><label>Nom<input data-n value="LeGeekShop"></label><label>URL<input data-u value="https://www.legeekshop.com"></label><label>Logo URL<input data-l></label><label>Téléphone<input data-p placeholder="+33…"></label><button type="button" class="lgk-outil__btn" data-gen>Générer JSON-LD</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const j = { '@context': 'https://schema.org', '@type': 'Organization', name: root.querySelector('[data-n]').value, url: root.querySelector('[data-u]').value };
          const l = root.querySelector('[data-l]').value;
          const p = root.querySelector('[data-p]').value;
          if (l) j.logo = l;
          if (p) j.telephone = p;
          root.querySelector('[data-out]').textContent = JSON.stringify(j, null, 2);
        });
        root.querySelector('[data-gen]').click();
      },
    },

    'utm-builder': {
      title: 'Constructeur UTM',
      render: () => `<div class="lgk-outil"><label>URL<input data-u value="https://www.legeekshop.com"></label><div class="lgk-outil__row lgk-outil__row--2"><label>Source<input data-s placeholder="newsletter"></label><label>Medium<input data-m placeholder="email"></label></div><label>Campaign<input data-c placeholder="promo-ete"></label><button type="button" class="lgk-outil__btn" data-gen>Construire</button><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const u = new URL(root.querySelector('[data-u]').value || 'https://example.com');
          [['utm_source', '[data-s]'], ['utm_medium', '[data-m]'], ['utm_campaign', '[data-c]']].forEach(([k, sel]) => {
            const v = root.querySelector(sel).value;
            if (v) u.searchParams.set(k, v);
          });
          root.querySelector('[data-out]').textContent = u.toString();
        });
      },
    },

    'open-graph-preview': {
      title: 'Aperçu Open Graph',
      render: () => `<div class="lgk-outil"><label>Titre<input data-t value="LeGeekShop — Mapping FiveM"></label><label>Description<textarea data-d rows="2">Boutique geek & FiveM</textarea></label><label>Image URL<input data-i></label><div class="lgk-outil__result" data-out style="border:1px solid #333;border-radius:8px;overflow:hidden"></div></div>`,
      mount(root) {
        const run = () => {
          const t = root.querySelector('[data-t]').value;
          const d = root.querySelector('[data-d]').value;
          const i = root.querySelector('[data-i]').value;
          root.querySelector('[data-out]').innerHTML = `${i ? `<img src="${i}" alt="" style="width:100%;max-height:160px;object-fit:cover">` : '<div style="height:120px;background:#222"></div>'}<div style="padding:0.75rem"><strong>${t}</strong><p style="margin:0.35rem 0 0;font-size:0.8rem;opacity:0.7">${d}</p><small style="opacity:0.5">legeekshop.com</small></div>`;
        };
        root.querySelectorAll('input,textarea').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'canonical-compare': {
      title: 'Compareur d\'URL',
      render: () => `<div class="lgk-outil"><label>URL A<input data-a></label><label>URL B<input data-b></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const norm = (s) => { try { const u = new URL(s.trim()); u.hash = ''; return u.href.replace(/\/$/, ''); } catch { return null; } };
        const run = () => {
          const a = norm(root.querySelector('[data-a]').value);
          const b = norm(root.querySelector('[data-b]').value);
          const out = root.querySelector('[data-out]');
          if (!a || !b) { out.textContent = 'URLs invalides'; return; }
          out.textContent = a === b ? '✓ URLs canoniquement identiques' : '✗ URLs différentes';
          out.className = 'lgk-outil__result' + (a === b ? '' : ' lgk-outil__result--warn');
        };
        root.querySelector('[data-a]').addEventListener('input', run);
        root.querySelector('[data-b]').addEventListener('input', run);
      },
    },

    'readability-score': {
      title: 'Lisibilité (approx.)',
      render: () => `<div class="lgk-outil"><label>Texte<textarea data-t rows="6"></textarea></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-t]').addEventListener('input', () => {
          const t = root.querySelector('[data-t]').value;
          const s = t.split(/[.!?]+/).filter(Boolean).length || 1;
          const w = (t.match(/[\p{L}\p{N}]+/gu) || []).length || 1;
          const avg = w / s;
          let label = avg < 12 ? 'Facile à lire' : avg < 18 ? 'Standard web' : 'Dense — simplifiez';
          root.querySelector('[data-out]').textContent = `${w} mots · ${s} phrases · ~${avg.toFixed(1)} mots/phrase · ${label}`;
        });
      },
    },

    'css-minify': {
      title: 'Minifier CSS',
      render: () => `<div class="lgk-outil"><label>CSS<textarea data-c rows="8" placeholder=".btn { color: red; }"></textarea></label><button type="button" class="lgk-outil__btn" data-go>Minifier</button><textarea class="lgk-outil__result" data-out rows="4" readonly></textarea></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          root.querySelector('[data-out]').value = root.querySelector('[data-c]').value.replace(/\/\*[\s\S]*?\*\//g, '').replace(/\s+/g, ' ').replace(/\s*([{}:;,])\s*/g, '$1').trim();
        });
      },
    },

    'image-compress': {
      title: 'Compresseur d\'images',
      render: () => `<div class="lgk-outil"><label>Fichier image<input type="file" data-f accept="image/*"></label><label>Qualité JPEG (0.1–1)<input type="range" data-q min="0.1" max="1" step="0.05" value="0.8"></label><div class="lgk-outil__result" data-out></div><a data-dl style="display:none" class="lgk-outil__btn" download="compressed.jpg">Télécharger</a></div>`,
      mount(root) {
        const f = root.querySelector('[data-f]');
        const q = root.querySelector('[data-q]');
        const out = root.querySelector('[data-out]');
        const dl = root.querySelector('[data-dl]');
        f.addEventListener('change', () => {
          const file = f.files[0];
          if (!file) return;
          const img = new Image();
          img.onload = () => {
            const c = document.createElement('canvas');
            c.width = img.width; c.height = img.height;
            c.getContext('2d').drawImage(img, 0, 0);
            c.toBlob((blob) => {
              out.textContent = `${file.name}: ${(file.size / 1024).toFixed(0)} Ko → ${(blob.size / 1024).toFixed(0)} Ko`;
              dl.href = URL.createObjectURL(blob);
              dl.style.display = 'inline-flex';
            }, 'image/jpeg', parseFloat(q.value));
          };
          img.src = URL.createObjectURL(file);
        });
        q.addEventListener('input', () => f.dispatchEvent(new Event('change')));
      },
    },

    'qr-code': {
      title: 'Générateur QR code',
      render: () => `<div class="lgk-outil"><label>Texte ou URL<input data-t value="https://www.legeekshop.com"></label><button type="button" class="lgk-outil__btn" data-go>Générer</button><div data-out style="text-align:center;margin-top:0.5rem"></div></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          const t = encodeURIComponent(root.querySelector('[data-t]').value);
          root.querySelector('[data-out]').innerHTML = `<img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${t}" alt="QR" width="200" height="200">`;
        });
        root.querySelector('[data-go]').click();
      },
    },

    'responsive-sim': {
      title: 'Simulateur responsive',
      render: () => `<div class="lgk-outil"><label>URL à prévisualiser<input data-u value="https://www.legeekshop.com"></label><label>Largeur (px)<select data-w><option value="390">iPhone 15 (390)</option><option value="412">Pixel 8 (412)</option><option value="768">iPad (768)</option><option value="1280" selected>Desktop (1280)</option><option value="1920">Full HD (1920)</option></select></label><div style="border:2px solid #444;border-radius:8px;overflow:hidden;margin-top:0.5rem"><iframe data-if style="width:100%;height:320px;border:0" sandbox="allow-scripts allow-same-origin"></iframe></div></div>`,
      mount(root) {
        const run = () => {
          const w = root.querySelector('[data-w]').value;
          const ifr = root.querySelector('[data-if]');
          ifr.style.maxWidth = w + 'px';
          ifr.src = root.querySelector('[data-u]').value;
        };
        root.querySelector('[data-w]').addEventListener('change', run);
        root.querySelector('[data-u]').addEventListener('change', run);
        run();
      },
    },

    'dead-pixel-test': {
      title: 'Test pixels morts',
      render: () => `<div class="lgk-outil"><p class="lgk-outil__hint">Cliquez pour changer de couleur plein écran.</p><div class="lgk-outil__actions"><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-c="#ff0000">Rouge</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-c="#00ff00">Vert</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-c="#0000ff">Bleu</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-c="#ffffff">Blanc</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-c="#000000">Noir</button></div><div data-sw style="height:120px;border-radius:8px;margin-top:0.5rem;cursor:pointer"></div></div>`,
      mount(root) {
        const sw = root.querySelector('[data-sw]');
        root.querySelectorAll('[data-c]').forEach((b) => b.addEventListener('click', () => { sw.style.background = b.dataset.c; }));
        sw.addEventListener('click', () => {
          if (document.documentElement.requestFullscreen) {
            sw.style.position = 'fixed'; sw.style.inset = '0'; sw.style.zIndex = '99999'; sw.style.height = '100vh';
            document.documentElement.requestFullscreen?.();
          }
        });
        sw.style.background = '#ff0000';
      },
    },

    'hreflang-helper': {
      title: 'Générateur hreflang',
      render: () => `<div class="lgk-outil"><label>Chemin (sans domaine)<input data-p value="/collections/fivem-mapping-collection"></label><label>Domaine FR<input data-fr value="https://www.legeekshop.com"></label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const p = root.querySelector('[data-p]').value;
          const fr = root.querySelector('[data-fr]').value.replace(/\/$/, '');
          root.querySelector('[data-out]').textContent = `<link rel="alternate" hreflang="fr" href="${fr}${p}">\n<link rel="alternate" hreflang="en" href="${fr}/en${p}">\n<link rel="alternate" hreflang="x-default" href="${fr}${p}">`;
        });
        root.querySelector('[data-gen]').click();
      },
    },

    timestamp: {
      title: 'Convertisseur timestamp',
      render: () => `<div class="lgk-outil"><label>Unix timestamp<input data-ts></label><label>Date/heure<input type="datetime-local" data-dt></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const ts = root.querySelector('[data-ts]');
        const dt = root.querySelector('[data-dt]');
        const out = root.querySelector('[data-out]');
        const now = Math.floor(Date.now() / 1000);
        ts.value = now;
        dt.value = new Date().toISOString().slice(0, 16);
        ts.addEventListener('input', () => {
          const d = new Date(parseInt(ts.value, 10) * 1000);
          dt.value = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
          out.textContent = d.toLocaleString('fr-FR');
        });
        dt.addEventListener('change', () => {
          const n = Math.floor(new Date(dt.value).getTime() / 1000);
          ts.value = n;
          out.textContent = `Unix: ${n}`;
        });
        ts.dispatchEvent(new Event('input'));
      },
    },

    'diff-text': {
      title: 'Diff texte',
      render: () => `<div class="lgk-outil"><label>Texte A<textarea data-a rows="4"></textarea></label><label>Texte B<textarea data-b rows="4"></textarea></label><pre class="lgk-outil__result" data-out style="font-size:0.75rem;max-height:12rem;overflow:auto"></pre></div>`,
      mount(root) {
        const run = () => {
          const a = root.querySelector('[data-a]').value.split('\n');
          const b = root.querySelector('[data-b]').value.split('\n');
          const max = Math.max(a.length, b.length);
          let o = '';
          for (let i = 0; i < max; i++) {
            const la = a[i] ?? ''; const lb = b[i] ?? '';
            if (la !== lb) o += `L${i + 1} − ${la}\nL${i + 1} + ${lb}\n`;
          }
          root.querySelector('[data-out]').textContent = o || 'Identiques';
        };
        root.querySelector('[data-a]').addEventListener('input', run);
        root.querySelector('[data-b]').addEventListener('input', run);
      },
    },

    'hsl-converter': {
      title: 'HEX ↔ HSL',
      render: () => `<div class="lgk-outil"><label>HEX<input data-h value="#6366f1"></label><div class="lgk-outil__result" data-out></div><div data-sw style="height:48px;border-radius:8px;margin-top:0.5rem"></div></div>`,
      mount(root) {
        const inp = root.querySelector('[data-h]');
        const out = root.querySelector('[data-out]');
        const sw = root.querySelector('[data-sw]');
        inp.addEventListener('input', () => {
          let h = inp.value.replace('#', '');
          if (h.length === 3) h = h.split('').map((c) => c + c).join('');
          const r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
          const max = Math.max(r, g, b), min = Math.min(r, g, b);
          let hue, sat, light = (max + min) / 2;
          if (max === min) hue = sat = 0;
          else {
            const d = max - min;
            sat = light > 0.5 ? d / (2 - max - min) : d / (max + min);
            if (max === r) hue = ((g - b) / d + (g < b ? 6 : 0)) / 6;
            else if (max === g) hue = ((b - r) / d + 2) / 6;
            else hue = ((r - g) / d + 4) / 6;
          }
          out.textContent = `hsl(${Math.round(hue * 360)}, ${Math.round(sat * 100)}%, ${Math.round(light * 100)}%)`;
          sw.style.background = inp.value.startsWith('#') ? inp.value : '#' + inp.value;
        });
        inp.dispatchEvent(new Event('input'));
      },
    },

    'gradient-css': {
      title: 'Dégradé CSS',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__row lgk-outil__row--2"><label>Couleur 1<input type="color" data-c1 value="#6366f1"></label><label>Couleur 2<input type="color" data-c2 value="#22d3ee"></label></div><label>Angle<input type="range" data-ang min="0" max="360" value="135"></label><div data-sw style="height:80px;border-radius:8px"></div><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        const run = () => {
          const c1 = root.querySelector('[data-c1]').value;
          const c2 = root.querySelector('[data-c2]').value;
          const a = root.querySelector('[data-ang]').value;
          const css = `linear-gradient(${a}deg, ${c1}, ${c2})`;
          root.querySelector('[data-sw]').style.background = css;
          root.querySelector('[data-out]').textContent = `background: ${css};`;
        };
        root.querySelectorAll('input').forEach((i) => i.addEventListener('input', run));
        run();
      },
    },

    'regex-test': {
      title: 'Testeur regex',
      render: () => `<div class="lgk-outil"><label>Expression<input data-r placeholder="[a-z]+"></label><label>Texte<textarea data-t rows="4"></textarea></label><label><input type="checkbox" data-g> Flag g (global)</label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          try {
            const re = new RegExp(root.querySelector('[data-r]').value, root.querySelector('[data-g]').checked ? 'g' : '');
            const m = root.querySelector('[data-t]').value.match(re);
            root.querySelector('[data-out]').textContent = m ? `Match: ${m.join(', ')}` : 'Aucun match';
          } catch (e) { root.querySelector('[data-out]').textContent = 'Regex invalide'; }
        };
        root.querySelectorAll('input,textarea').forEach((el) => el.addEventListener('input', run));
      },
    },

    'jwt-decode': {
      title: 'Décodeur JWT',
      render: () => `<div class="lgk-outil"><label>Token JWT<textarea data-j rows="4" placeholder="eyJ…"></textarea></label><pre class="lgk-outil__result" data-out style="font-size:0.7rem;max-height:14rem;overflow:auto"></pre></div>`,
      mount(root) {
        root.querySelector('[data-j]').addEventListener('input', () => {
          try {
            const [h, p] = root.querySelector('[data-j]').value.trim().split('.');
            const dec = (s) => JSON.parse(atob(s.replace(/-/g, '+').replace(/_/g, '/')));
            root.querySelector('[data-out]').textContent = JSON.stringify({ header: dec(h), payload: dec(p) }, null, 2);
          } catch { root.querySelector('[data-out]').textContent = 'JWT invalide'; }
        });
      },
    },

    'base-convert': {
      title: 'Convertisseur de bases',
      render: () => `<div class="lgk-outil"><label>Décimal<input data-d value="255"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-d]').addEventListener('input', () => {
          const n = parseInt(root.querySelector('[data-d]').value, 10);
          if (isNaN(n)) return;
          root.querySelector('[data-out]').innerHTML = `Bin: ${n.toString(2)}<br>Oct: ${n.toString(8)}<br>Hex: ${n.toString(16).toUpperCase()}`;
        });
        root.querySelector('[data-d]').dispatchEvent(new Event('input'));
      },
    },

    'yaml-json': {
      title: 'YAML → JSON',
      render: () => `<div class="lgk-outil"><label>YAML simplifié<textarea data-y rows="6" placeholder="cle: valeur\nliste:\n  - a\n  - b"></textarea></label><button type="button" class="lgk-outil__btn" data-go>Convertir</button><pre class="lgk-outil__result" data-out></pre><p class="lgk-outil__hint">YAML basique (clé: valeur, listes - item).</p></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          const lines = root.querySelector('[data-y]').value.split('\n');
          const obj = {};
          let listKey = null;
          lines.forEach((line) => {
            const t = line.trim();
            if (!t) return;
            if (t.startsWith('- ')) {
              if (!listKey) return;
              (obj[listKey] = obj[listKey] || []).push(t.slice(2).trim());
            } else if (t.includes(':')) {
              const [k, ...v] = t.split(':');
              const val = v.join(':').trim();
              if (!val) { listKey = k.trim(); obj[listKey] = []; }
              else { obj[k.trim()] = val; listKey = null; }
            }
          });
          root.querySelector('[data-out]').textContent = JSON.stringify(obj, null, 2);
        });
      },
    },

    'chmod-calc': {
      title: 'Calculateur chmod',
      render: () => `<div class="lgk-outil"><label>Permissions (ex. rwxr-xr-x)<input data-p value="rwxr-xr-x"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const p = root.querySelector('[data-p]').value.padEnd(9, '-').slice(0, 9);
          const chunk = (s) => (s[0] === 'r' ? 4 : 0) + (s[1] === 'w' ? 2 : 0) + (s[2] === 'x' ? 1 : 0);
          const n = '' + chunk(p.slice(0, 3)) + chunk(p.slice(3, 6)) + chunk(p.slice(6, 9));
          root.querySelector('[data-out]').textContent = `chmod ${n} (octal)`;
        };
        root.querySelector('[data-p]').addEventListener('input', run);
        run();
      },
    },

    'gitignore-gen': {
      title: 'Générateur .gitignore',
      render: () => `<div class="lgk-outil"><label>Stack<select data-s><option value="node">Node.js</option><option value="shopify">Shopify theme</option><option value="fivem">FiveM resource</option><option value="python">Python</option></select></label><button type="button" class="lgk-outil__btn" data-go>Générer</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        const MAP = {
          node: 'node_modules/\n.env\n.dist/\nbuild/\n*.log\n.DS_Store',
          shopify: 'node_modules/\n.env\n.shopify/\nconfig/settings_data.json.bak\n.DS_Store',
          fivem: '*.log\n.cache/\nfxmanifest.lua.bak\nstream/*.ytd.bak',
          python: '__pycache__/\n*.pyc\n.venv/\n.env\n.pytest_cache/',
        };
        root.querySelector('[data-go]').addEventListener('click', () => {
          root.querySelector('[data-out]').textContent = MAP[root.querySelector('[data-s]').value] || '';
        });
        root.querySelector('[data-go]').click();
      },
    },

    'markdown-preview': {
      title: 'Aperçu Markdown',
      render: () => `<div class="lgk-outil"><label>Markdown<textarea data-m rows="6"># Titre\n\n**gras** et [lien](https://legeekshop.com)</textarea></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-m]').addEventListener('input', () => {
          let h = root.querySelector('[data-m]').value;
          h = h.replace(/^### (.*)$/gm, '<h3>$1</h3>').replace(/^## (.*)$/gm, '<h2>$1</h2>').replace(/^# (.*)$/gm, '<h1>$1</h1>');
          h = h.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>');
          h = h.replace(/\n/g, '<br>');
          root.querySelector('[data-out]').innerHTML = h;
        });
        root.querySelector('[data-m]').dispatchEvent(new Event('input'));
      },
    },

    'html-encode': {
      title: 'Encodeur HTML',
      render: () => `<div class="lgk-outil"><label>Texte<textarea data-t rows="4" placeholder="Texte à encoder"></textarea></label><button type="button" class="lgk-outil__btn" data-go>Encoder</button><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          const d = document.createElement('div');
          d.textContent = root.querySelector('[data-t]').value;
          root.querySelector('[data-out]').textContent = d.innerHTML;
        });
      },
    },

    'shopify-fees': {
      title: 'Frais Shopify',
      render: () => `<div class="lgk-outil"><label>CA mensuel (€)<input data-ca value="5000"></label><label>Plan<select data-plan><option value="29">Basic 29€</option><option value="79" selected>Shopify 79€</option><option value="299">Advanced 299€</option></select></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const ca = parseFloat(root.querySelector('[data-ca]').value) || 0;
          const plan = parseFloat(root.querySelector('[data-plan]').value);
          const pct = 0.017;
          const fees = plan + ca * pct;
          root.querySelector('[data-out]').textContent = `Frais estimés: ${fees.toFixed(2)} €/mois (abonnement + ${(pct * 100).toFixed(1)} % transactions)`;
        };
        root.querySelectorAll('input,select').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'shopify-profit': {
      title: 'Rentabilité Shopify',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__row lgk-outil__row--2"><label>CA (€)<input data-ca value="10000"></label><label>Coût produits (€)<input data-cost value="4000"></label></div><div class="lgk-outil__row lgk-outil__row--2"><label>Pub (€)<input data-ads value="1500"></label><label>Frais fixes (€)<input data-fix value="200"></label></div><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const ca = parseFloat(root.querySelector('[data-ca]').value) || 0;
          const cost = parseFloat(root.querySelector('[data-cost]').value) || 0;
          const ads = parseFloat(root.querySelector('[data-ads]').value) || 0;
          const fix = parseFloat(root.querySelector('[data-fix]').value) || 0;
          const shopify = 79 + ca * 0.017;
          const net = ca - cost - ads - fix - shopify;
          const margin = ca ? ((net / ca) * 100).toFixed(1) : 0;
          root.querySelector('[data-out]').textContent = `Marge nette: ${net.toFixed(2)} € (${margin} %) · Seuil rentabilité pub: ${(ca - cost - fix - shopify).toFixed(0)} € max`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'bundle-price': {
      title: 'Prix pack / bundle',
      render: () => `<div class="lgk-outil"><label>Prix unitaires (séparés par ,)<input data-p value="29.99,24.99,9.99"></label><label>Prix pack (€)<input data-b value="49.99"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const sum = root.querySelector('[data-p]').value.split(',').reduce((s, v) => s + (parseFloat(v) || 0), 0);
          const b = parseFloat(root.querySelector('[data-b]').value) || 0;
          root.querySelector('[data-out]').textContent = `Séparé: ${sum.toFixed(2)} € · Pack: ${b.toFixed(2)} € · Économie: ${(sum - b).toFixed(2)} € (${sum ? (((sum - b) / sum) * 100).toFixed(0) : 0} %)`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'break-even': {
      title: 'Seuil de rentabilité',
      render: () => `<div class="lgk-outil"><label>Coûts fixes / mois (€)<input data-fix value="2000"></label><label>Marge unitaire (€)<input data-unit value="15"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const f = parseFloat(root.querySelector('[data-fix]').value) || 0;
          const u = parseFloat(root.querySelector('[data-unit]').value) || 1;
          root.querySelector('[data-out]').textContent = `Seuil: ${Math.ceil(f / u)} ventes/mois pour couvrir les coûts fixes`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'roi-ads': {
      title: 'ROI publicité',
      render: () => `<div class="lgk-outil"><label>Dépense pub (€)<input data-spend value="500"></label><label>Revenu généré (€)<input data-rev value="2000"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const s = parseFloat(root.querySelector('[data-spend]').value) || 0;
          const r = parseFloat(root.querySelector('[data-rev]').value) || 0;
          const roi = s ? (((r - s) / s) * 100).toFixed(1) : 0;
          root.querySelector('[data-out]').textContent = `ROI: ${roi} % · ROAS: ${s ? (r / s).toFixed(2) : 0}:1`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'klarna-3x': {
      title: 'Simulateur 3× Klarna',
      render: () => `<div class="lgk-outil"><label>Montant total (€)<input data-t value="150"></label><div class="lgk-outil__result" data-out></div><p class="lgk-outil__hint">Indicatif — frais Klarna non inclus.</p></div>`,
      mount(root) {
        root.querySelector('[data-t]').addEventListener('input', () => {
          const t = parseFloat(root.querySelector('[data-t]').value) || 0;
          root.querySelector('[data-out]').textContent = `3 × ${(t / 3).toFixed(2)} €`;
        });
        root.querySelector('[data-t]').dispatchEvent(new Event('input'));
      },
    },

    'loyalty-points': {
      title: 'Points fidélité',
      render: () => `<div class="lgk-outil"><label>Points<input data-p value="500"></label><label>Valeur: 1 pt = (€)<input data-v value="0.01" step="0.001"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const p = parseFloat(root.querySelector('[data-p]').value) || 0;
          const v = parseFloat(root.querySelector('[data-v]').value) || 0.01;
          root.querySelector('[data-out]').textContent = `Valeur: ${(p * v).toFixed(2)} € de réduction possible`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'devis-estimate': {
      title: 'Estimateur devis web',
      render: () => `<div class="lgk-outil"><label>Type<select data-t><option value="150-490">Site vitrine 1 page</option><option value="490-1490">Site multi-pages / Starter</option><option value="1490-5000">Shopify / E-commerce</option><option value="5000+">SaaS / sur mesure</option></select></label><div class="lgk-outil__result" data-out></div><p class="lgk-outil__hint">Fourchette GothamDev — <a href="https://gothamdev.fr/contact.html" target="_blank" rel="noopener">devis exact sous 48 h</a></p></div>`,
      mount(root) {
        root.querySelector('[data-t]').addEventListener('change', () => {
          const v = root.querySelector('[data-t]').value;
          root.querySelector('[data-out]').textContent = `Fourchette indicative: ${v.replace('+', ' € et +').replace('-', ' – ')} €`;
        });
        root.querySelector('[data-t]').dispatchEvent(new Event('change'));
      },
    },

    'edpi-calc': {
      title: 'Calculateur eDPI',
      render: () => `<div class="lgk-outil"><label>DPI souris<input data-dpi value="800"></label><label>Sensibilité en jeu<input data-sens value="0.5" step="0.01"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const e = (parseFloat(root.querySelector('[data-dpi]').value) || 0) * (parseFloat(root.querySelector('[data-sens]').value) || 0);
          root.querySelector('[data-out]').textContent = `eDPI: ${e.toFixed(0)} (pro FPS souvent 400–1600)`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'sens-cm360': {
      title: 'cm/360°',
      render: () => `<div class="lgk-outil"><label>DPI<input data-d value="800"></label><label>Sens<input data-s value="2" step="0.1"></label><label>Yaw (CS:GO=0.022)<input data-y value="0.022" step="0.001"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const d = parseFloat(root.querySelector('[data-d]').value) || 800;
          const s = parseFloat(root.querySelector('[data-s]').value) || 1;
          const y = parseFloat(root.querySelector('[data-y]').value) || 0.022;
          const cm = (360 * 2.54) / (d * s * y);
          root.querySelector('[data-out]').textContent = `~${cm.toFixed(1)} cm pour 360°`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'fps-calc': {
      title: 'Calculette FPS',
      render: () => `<div class="lgk-outil"><label>GPU<select data-g><option value="1">RTX 4060</option><option value="1.4">RTX 4070</option><option value="2">RTX 4080</option><option value="0.6">GTX 1660</option></select></label><label>Jeu<select data-j><option value="1">Compétitif (Valorant)</option><option value="0.7">AAA récent</option><option value="0.5">Cyberpunk max</option></select></label><label>Résolution<select data-r><option value="1">1080p</option><option value="0.72">1440p</option><option value="0.45">4K</option></select></label><div class="lgk-outil__result" data-out></div><p class="lgk-outil__hint">Estimation relative, pas benchmark réel.</p></div>`,
      mount(root) {
        const run = () => {
          const base = 120 * parseFloat(root.querySelector('[data-g]').value) * parseFloat(root.querySelector('[data-j]').value) * parseFloat(root.querySelector('[data-r]').value);
          root.querySelector('[data-out]').textContent = `FPS estimés: ~${Math.round(base)} (indicatif)`;
        };
        root.querySelectorAll('select').forEach((el) => el.addEventListener('change', run));
        run();
      },
    },

    'budget-pc': {
      title: 'Budget PC gaming',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__row lgk-outil__row--2"><label>CPU (€)<input data-cpu value="250"></label><label>GPU (€)<input data-gpu value="450"></label></div><div class="lgk-outil__row lgk-outil__row--2"><label>RAM (€)<input data-ram value="80"></label><label>Reste (€)<input data-rest value="350"></label></div><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const t = ['cpu', 'gpu', 'ram', 'rest'].reduce((s, k) => s + (parseFloat(root.querySelector(`[data-${k}]`).value) || 0), 0);
          let tier = t < 700 ? 'Entrée de gamme' : t < 1200 ? 'Milieu de gamme' : t < 2000 ? 'Haut de gamme' : 'Enthusiast';
          root.querySelector('[data-out]').textContent = `Total: ${t.toFixed(2)} € · Tier: ${tier}`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'download-time': {
      title: 'Temps de téléchargement',
      render: () => `<div class="lgk-outil"><label>Taille (Go)<input data-s value="50"></label><label>Débit (Mbps)<input data-m value="100"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const gb = parseFloat(root.querySelector('[data-s]').value) || 0;
          const mbps = parseFloat(root.querySelector('[data-m]').value) || 1;
          const sec = (gb * 1024 * 8) / mbps;
          const h = Math.floor(sec / 3600); const m = Math.floor((sec % 3600) / 60);
          root.querySelector('[data-out]').textContent = sec < 60 ? `${sec.toFixed(0)} s` : h ? `${h} h ${m} min` : `${m} min`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'storage-games': {
      title: 'Espace disque jeux',
      render: () => `<div class="lgk-outil"><label>Tailles en Go (séparées par ,)<input data-g value="80,120,45,60"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-g]').addEventListener('input', () => {
          const sum = root.querySelector('[data-g]').value.split(',').reduce((s, v) => s + (parseFloat(v) || 0), 0);
          root.querySelector('[data-out]').textContent = `Total: ${sum.toFixed(1)} Go · Prévoir ${(sum * 1.15).toFixed(0)} Go avec marge`;
        });
        root.querySelector('[data-g]').dispatchEvent(new Event('input'));
      },
    },

    'steam-id': {
      title: 'Steam ID parser',
      render: () => `<div class="lgk-outil"><label>URL ou ID Steam<input data-u placeholder="https://steamcommunity.com/profiles/7656119…"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-u]').addEventListener('input', () => {
          const u = root.querySelector('[data-u]').value;
          const m = u.match(/profiles\/(\d+)/) || u.match(/^(\d{17})$/);
          root.querySelector('[data-out]').textContent = m ? `SteamID64: ${m[1]}` : 'Format non reconnu';
        });
      },
    },

    'checklist-fivem': {
      title: 'Checklist FiveM',
      render: () => `<div class="lgk-outil" data-out></div>`,
      mount(root) {
        const items = ['Visual C++ 2015–2022 installés', 'DirectX / .NET à jour', 'Cache FiveM vidé (Repair Kit)', 'Pilotes GPU à jour', 'Antivirus exclusion FiveM', 'Port 30120 ouvert (serveur)', 'Artifact serveur récent'];
        root.innerHTML = items.map((t, i) => `<label style="display:flex;gap:0.5rem;margin:0.35rem 0"><input type="checkbox" data-i="${i}"> ${t}</label>`).join('') + '<div class="lgk-outil__result" data-sum style="margin-top:0.75rem"></div>';
        const sum = root.querySelector('[data-sum]');
        root.querySelectorAll('input[type=checkbox]').forEach((cb) => cb.addEventListener('change', () => {
          const n = root.querySelectorAll('input:checked').length;
          sum.textContent = `${n}/${items.length} — ${n === items.length ? 'Prêt à jouer !' : 'Complétez la checklist'}`;
        }));
      },
    },

    'monitor-refresh': {
      title: 'Hz & frame time',
      render: () => `<div class="lgk-outil"><label>Refresh rate (Hz)<select data-hz><option>60</option><option>75</option><option>120</option><option selected>144</option><option>240</option></select></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-hz]').addEventListener('change', () => {
          const hz = parseFloat(root.querySelector('[data-hz]').value);
          root.querySelector('[data-out]').textContent = `Frame time cible: ${(1000 / hz).toFixed(2)} ms · ${hz} FPS max écran`;
        });
        root.querySelector('[data-hz]').dispatchEvent(new Event('change'));
      },
    },

    'coords-lua': {
      title: 'Coords → vector3 Lua',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__row lgk-outil__row--2"><label>X<input data-x value="0"></label><label>Y<input data-y value="0"></label></div><div class="lgk-outil__row lgk-outil__row--2"><label>Z<input data-z value="72"></label><label>Heading<input data-h value="90"></label></div><button type="button" class="lgk-outil__btn" data-copy>Copier</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        const run = () => {
          const x = root.querySelector('[data-x]').value, y = root.querySelector('[data-y]').value, z = root.querySelector('[data-z]').value, h = root.querySelector('[data-h]').value;
          root.querySelector('[data-out]').textContent = `vector3(${x}, ${y}, ${z}), heading = ${h}\n-- ou\n{x = ${x}, y = ${y}, z = ${z}, w = ${h}}`;
        };
        root.querySelectorAll('input').forEach((i) => i.addEventListener('input', run));
        copyBtn(root, () => root.querySelector('[data-out]').textContent);
        run();
      },
    },

    'fivem-cfg': {
      title: 'Générateur server.cfg',
      render: () => `<div class="lgk-outil"><label>Nom serveur<input data-n value="Mon Serveur RP"></label><label>Slots<input data-s value="48"></label><label>License key (placeholder)<input data-k value="changeme"></label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><pre class="lgk-outil__result" data-out style="font-size:0.7rem;max-height:14rem;overflow:auto"></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          root.querySelector('[data-out]').textContent = `sv_hostname "${root.querySelector('[data-n]').value}"\nsv_maxclients ${root.querySelector('[data-s]').value}\nsv_licenseKey "${root.querySelector('[data-k]').value}"\nsets tags "roleplay,french"\nensure mapmanager\nensure chat\nensure spawnmanager\nensure sessionmanager\nensure basic-gamemode\nensure hardcap`;
        });
      },
    },

    'fivem-resources': {
      title: 'Liste → ensure',
      render: () => `<div class="lgk-outil"><label>Noms resources (un par ligne)<textarea data-r rows="8" placeholder="ox_lib\nox_inventory\nes_extended"></textarea></label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const lines = root.querySelector('[data-r]').value.split('\n').map((l) => l.trim()).filter(Boolean);
          root.querySelector('[data-out]').textContent = lines.map((l) => `ensure ${l}`).join('\n');
        });
      },
    },

    'lua-json': {
      title: 'JSON → table Lua',
      render: () => `<div class="lgk-outil"><label>JSON<textarea data-j rows="6">{"name":"test","count":3}</textarea></label><button type="button" class="lgk-outil__btn" data-go>Convertir</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        const toLua = (obj, indent) => {
          const sp = '  '.repeat(indent);
          if (Array.isArray(obj)) return '{\n' + obj.map((v) => sp + '  ' + toLua(v, indent + 1)).join(',\n') + '\n' + sp + '}';
          if (obj && typeof obj === 'object') return '{\n' + Object.entries(obj).map(([k, v]) => `${sp}  ${/^[a-z_]\w*$/i.test(k) ? k : `["${k}"]`} = ${toLua(v, indent + 1)}`).join(',\n') + '\n' + sp + '}';
          if (typeof obj === 'string') return `"${obj.replace(/"/g, '\\"')}"`;
          return String(obj);
        };
        root.querySelector('[data-go]').addEventListener('click', () => {
          try { root.querySelector('[data-out]').textContent = toLua(JSON.parse(root.querySelector('[data-j]').value), 0); }
          catch { root.querySelector('[data-out]').textContent = 'JSON invalide'; }
        });
      },
    },

    'fivem-perf': {
      title: 'Budget OneSync',
      render: () => `<div class="lgk-outil"><label>Slots joueurs<input data-s value="64"></label><label>Resources estimées<input data-r value="120"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const s = parseInt(root.querySelector('[data-s]').value, 10) || 32;
          const r = parseInt(root.querySelector('[data-r]').value, 10) || 80;
          root.querySelector('[data-out]').textContent = s > 48 ? 'OneSync recommandé · RAM serveur 16 Go+ · CPU 4.5 GHz+' : 'Legacy possible · surveillez la RAM au-delà de 80 resources';
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'fivem-ace': {
      title: 'Générateur ACE',
      render: () => `<div class="lgk-outil"><label>Identifier<input data-id value="license:abc123"></label><label>Groupe<input data-g value="admin"></label><button type="button" class="lgk-outil__btn" data-gen>Générer</button><pre class="lgk-outil__result" data-out></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const id = root.querySelector('[data-id]').value;
          const g = root.querySelector('[data-g]').value;
          root.querySelector('[data-out]').textContent = `add_principal identifier.${id} group.${g}\nadd_ace group.${g} command allow`;
        });
      },
    },

    'fivem-txadmin': {
      title: 'Notes txAdmin',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__result lgk-outil__result--muted"><ul style="margin:0;padding-left:1.2rem"><li>Artifact Linux/Windows à jour</li><li>License key Cfx.re valide</li><li>Port 40120 (txAdmin) + 30120 (game)</li><li>Backup server.cfg avant modif</li><li>Monitor RAM & CPU via txAdmin</li></ul></div></div>`,
      mount() {},
    },

    'discord-webhook': {
      title: 'Embed Discord JSON',
      render: () => `<div class="lgk-outil"><label>Titre<input data-t value="Annonce LeGeekShop"></label><label>Description<textarea data-d rows="3">Nouveau mapping FiveM disponible !</textarea></label><label>Couleur (hex)<input data-c value="#6366f1"></label><button type="button" class="lgk-outil__btn" data-gen>JSON embed</button><pre class="lgk-outil__result" data-out style="font-size:0.7rem"></pre></div>`,
      mount(root) {
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const col = parseInt(root.querySelector('[data-c]').value.replace('#', ''), 16);
          root.querySelector('[data-out]').textContent = JSON.stringify({ embeds: [{ title: root.querySelector('[data-t]').value, description: root.querySelector('[data-d]').value, color: col }] }, null, 2);
        });
      },
    },

    'age-calc': {
      title: 'Calculateur d\'âge',
      render: () => `<div class="lgk-outil"><label>Date de naissance<input type="date" data-d></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const d = root.querySelector('[data-d]');
        d.value = '1990-01-01';
        d.addEventListener('change', () => {
          const birth = new Date(d.value);
          const now = new Date();
          let age = now.getFullYear() - birth.getFullYear();
          const m = now.getMonth() - birth.getMonth();
          if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
          root.querySelector('[data-out]').textContent = `${age} ans`;
        });
        d.dispatchEvent(new Event('change'));
      },
    },

    'date-diff': {
      title: 'Différence de dates',
      render: () => `<div class="lgk-outil"><label>Date A<input type="date" data-a></label><label>Date B<input type="date" data-b></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const a = new Date(root.querySelector('[data-a]').value);
          const b = new Date(root.querySelector('[data-b]').value);
          const days = Math.round(Math.abs(b - a) / 86400000);
          root.querySelector('[data-out]').textContent = `${days} jour(s)`;
        };
        root.querySelectorAll('input').forEach((i) => i.addEventListener('change', run));
        root.querySelector('[data-a]').value = new Date().toISOString().slice(0, 10);
        root.querySelector('[data-b]').value = new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10);
        run();
      },
    },

    timezone: {
      title: 'Fuseaux horaires',
      render: () => `<div class="lgk-outil"><label>Heure locale<input type="datetime-local" data-dt></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const dt = root.querySelector('[data-dt]');
        dt.value = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);
        const zones = ['Europe/Paris', 'America/New_York', 'Asia/Tokyo', 'UTC'];
        dt.addEventListener('change', () => {
          const d = new Date(dt.value);
          root.querySelector('[data-out]').innerHTML = zones.map((z) => `${z}: ${d.toLocaleString('fr-FR', { timeZone: z })}`).join('<br>');
        });
        dt.dispatchEvent(new Event('change'));
      },
    },

    stopwatch: {
      title: 'Chronomètre',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__timer-display" data-d>00:00:00</div><div class="lgk-outil__actions"><button type="button" class="lgk-outil__btn" data-go>Start</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-stop>Stop</button><button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-reset>Reset</button></div></div>`,
      mount(root) {
        let t0 = 0, iv = null, el = 0;
        const d = root.querySelector('[data-d]');
        const fmt = (ms) => { const s = Math.floor(ms / 1000); return [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60].map((n) => String(n).padStart(2, '0')).join(':'); };
        root.querySelector('[data-go]').addEventListener('click', () => { if (!iv) { t0 = Date.now() - el; iv = setInterval(() => { el = Date.now() - t0; d.textContent = fmt(el); }, 100); } });
        root.querySelector('[data-stop]').addEventListener('click', () => { clearInterval(iv); iv = null; });
        root.querySelector('[data-reset]').addEventListener('click', () => { clearInterval(iv); iv = null; el = 0; d.textContent = '00:00:00'; });
      },
    },

    countdown: {
      title: 'Compte à rebours',
      render: () => `<div class="lgk-outil"><label>Date cible<input type="datetime-local" data-dt></label><div class="lgk-outil__timer-display" data-d>—</div></div>`,
      mount(root) {
        const dt = root.querySelector('[data-dt]');
        const d = root.querySelector('[data-d]');
        dt.value = new Date(Date.now() + 7 * 86400000 - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);
        setInterval(() => {
          const diff = new Date(dt.value) - Date.now();
          if (diff <= 0) { d.textContent = 'Terminé !'; return; }
          const days = Math.floor(diff / 86400000);
          const h = Math.floor((diff % 86400000) / 3600000);
          d.textContent = `${days}j ${h}h`;
        }, 1000);
      },
    },

    'dice-roll': {
      title: 'Lancer de dés',
      render: () => `<div class="lgk-outil"><label>Type<select data-t><option value="6">D6</option><option value="20">D20</option><option value="100">D100</option></select></label><label>Nombre<input data-n value="2" min="1" max="10"></label><button type="button" class="lgk-outil__btn" data-go>Lancer</button><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          const faces = parseInt(root.querySelector('[data-t]').value, 10);
          const n = parseInt(root.querySelector('[data-n]').value, 10) || 1;
          const rolls = Array.from({ length: n }, () => 1 + Math.floor(Math.random() * faces));
          root.querySelector('[data-out]').textContent = rolls.join(' + ') + ' = ' + rolls.reduce((a, b) => a + b, 0);
        });
      },
    },

    'coin-flip': {
      title: 'Pile ou face',
      render: () => `<div class="lgk-outil"><button type="button" class="lgk-outil__btn" data-go>Lancer</button><div class="lgk-outil__timer-display" data-out style="font-size:2rem">—</div></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          root.querySelector('[data-out]').textContent = Math.random() < 0.5 ? 'Pile' : 'Face';
        });
      },
    },

    'random-picker': {
      title: 'Tirage au sort',
      render: () => `<div class="lgk-outil"><label>Liste (un par ligne)<textarea data-l rows="6">Alice\nBob\nCharlie</textarea></label><button type="button" class="lgk-outil__btn" data-go>Tirer</button><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          const list = root.querySelector('[data-l]').value.split('\n').map((l) => l.trim()).filter(Boolean);
          root.querySelector('[data-out]').textContent = list.length ? `🎉 ${list[Math.floor(Math.random() * list.length)]}` : 'Liste vide';
        });
      },
    },

    'subnet-calc': {
      title: 'Sous-réseau IP',
      render: () => `<div class="lgk-outil"><label>IP<input data-ip value="192.168.1.0"></label><label>Masque / CIDR<input data-c value="24"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const run = () => {
          const cidr = parseInt(root.querySelector('[data-c]').value, 10) || 24;
          const hosts = Math.pow(2, 32 - cidr) - 2;
          root.querySelector('[data-out]').textContent = `~${hosts} hôtes utilisables · masque ${['255.0.0.0', '255.255.0.0', '255.255.255.0'][Math.floor(cidr / 8)] || '…'}`;
        };
        root.querySelectorAll('input').forEach((el) => el.addEventListener('input', run));
        run();
      },
    },

    'mime-lookup': {
      title: 'Types MIME',
      render: () => `<div class="lgk-outil"><label>Extension<input data-e value="webp"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-e]').addEventListener('input', () => {
          const e = root.querySelector('[data-e]').value.toLowerCase().replace(/^\./, '');
          root.querySelector('[data-out]').textContent = MIME[e] || 'application/octet-stream (inconnu)';
        });
        root.querySelector('[data-e]').dispatchEvent(new Event('input'));
      },
    },

    'color-contrast': {
      title: 'Contraste WCAG',
      render: () => `<div class="lgk-outil"><div class="lgk-outil__row lgk-outil__row--2"><label>Texte<input type="color" data-fg value="#ffffff"></label><label>Fond<input type="color" data-bg value="#6366f1"></label></div><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const lum = (hex) => {
          const h = hex.replace('#', '');
          const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) / 255);
          const f = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
          return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
        };
        const run = () => {
          const fg = root.querySelector('[data-fg]').value, bg = root.querySelector('[data-bg]').value;
          const ratio = (Math.max(lum(fg), lum(bg)) + 0.05) / (Math.min(lum(fg), lum(bg)) + 0.05);
          const ok = ratio >= 4.5 ? 'AA ✓' : ratio >= 3 ? 'Grand texte seulement' : 'Insuffisant';
          root.querySelector('[data-out]').textContent = `Ratio: ${ratio.toFixed(2)}:1 — ${ok}`;
        };
        root.querySelectorAll('input').forEach((i) => i.addEventListener('input', run));
        run();
      },
    },

    'iban-validator': {
      title: 'Validateur IBAN FR',
      render: () => `<div class="lgk-outil"><label>IBAN<input data-i placeholder="FR76…"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-i]').addEventListener('input', () => {
          const iban = root.querySelector('[data-i]').value.replace(/\s/g, '').toUpperCase();
          const ok = /^FR\d{2}[A-Z0-9]{23}$/.test(iban) && iban.length === 27;
          root.querySelector('[data-out]').textContent = ok ? 'Format IBAN FR valide' : 'Format invalide';
          root.querySelector('[data-out]').className = 'lgk-outil__result' + (ok ? '' : ' lgk-outil__result--warn');
        });
      },
    },

    'vat-number-fr': {
      title: 'N° TVA intracom FR',
      render: () => `<div class="lgk-outil"><label>SIREN (9 chiffres)<input data-s value="123456789" maxlength="9"></label><button type="button" class="lgk-outil__btn" data-go>Générer</button><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-go]').addEventListener('click', () => {
          const s = root.querySelector('[data-s]').value.replace(/\D/g, '').padStart(9, '0').slice(-9);
          const key = (12 + 3 * (parseInt(s, 10) % 97)) % 97;
          root.querySelector('[data-out]').textContent = `FR${String(key).padStart(2, '0')}${s}`;
        });
      },
    },

    'email-validator': {
      title: 'Validateur e-mail',
      render: () => `<div class="lgk-outil"><label>E-mail<input data-e placeholder="contact@legeekshop.com"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-e]').addEventListener('input', () => {
          const e = root.querySelector('[data-e]').value;
          const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
          root.querySelector('[data-out]').textContent = ok ? 'Format valide' : 'Format invalide';
        });
      },
    },

    'phone-fr': {
      title: 'Formater téléphone FR',
      render: () => `<div class="lgk-outil"><label>Numéro<input data-p placeholder="06 12 34 56 78"></label><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        root.querySelector('[data-p]').addEventListener('input', () => {
          let p = root.querySelector('[data-p]').value.replace(/\D/g, '');
          if (p.startsWith('0')) p = '33' + p.slice(1);
          root.querySelector('[data-out]').textContent = p.startsWith('33') ? `+${p}` : p;
        });
      },
    },
  });

  // TTC avec taux multiples
  if (T['ttc-ht']) {
    const orig = T['ttc-ht'];
    T['ttc-ht'] = {
      title: 'Calculateur TTC ↔ HT',
      render: () => `<div class="lgk-outil"><label>Taux TVA<select data-rate><option value="20">20 %</option><option value="10">10 %</option><option value="5.5">5,5 %</option></select></label><div class="lgk-outil__row lgk-outil__row--2"><label>HT<input type="number" step="0.01" data-ht></label><label>TTC<input type="number" step="0.01" data-ttc></label></div><div class="lgk-outil__result" data-out></div></div>`,
      mount(root) {
        const rate = root.querySelector('[data-rate]');
        const ht = root.querySelector('[data-ht]');
        const ttc = root.querySelector('[data-ttc]');
        const out = root.querySelector('[data-out]');
        const v = () => VAT[parseFloat(rate.value)] || 0.2;
        ht.addEventListener('input', () => { const h = parseFloat(ht.value); if (!isNaN(h)) { const t = h * (1 + v()); ttc.value = t.toFixed(2); out.textContent = `TVA: ${(t - h).toFixed(2)} €`; } });
        ttc.addEventListener('input', () => { const t = parseFloat(ttc.value); if (!isNaN(t)) { const h = t / (1 + v()); ht.value = h.toFixed(2); out.textContent = `HT: ${h.toFixed(2)} €`; } });
      },
    };
  }
})();
